var __jsx = React.createElement;
import React from 'react';
import Link from 'next/link';
import Image from 'next/image';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import styles from '../../styles/compare/OfferDetails.module.scss';
import * as gtag from '../../cookie/lib/gtag';

var PaydayLoanDetails = function PaydayLoanDetails(props) {
  var show = props.show,
      handleClose = props.handleClose,
      details = props.details,
      applyParams = props.applyParams,
      product = props.product;
  var provider = details.showLogo ? __jsx(Image, {
    src: details.providerLogo,
    height: details.logoSize.height,
    width: details.logoSize.width
  }) : __jsx("p", null, details.provider);
  var relOpennerTag;

  if (details.hasOwnProperty('apply')) {
    relOpennerTag = details.apply.indexOf(" ".concat(process.env.NEXT_PUBLIC_SITE_URL, " ")) > -1 ? '' : 'noopener';
  } else {
    relOpennerTag = '';
  }

  var onApply = function onApply() {
    if (window.location.hostname.indexOf('conso.ro') > 1) {
      gtag.event('Apply', {
        provider: details.provider,
        product: product
      });
    } else {
      console.log("beta");
    }

    handleClose();
  };

  return __jsx(Modal, {
    show: show,
    onHide: handleClose,
    dialogClassName: styles.modal90w
  }, __jsx(Modal.Header, {
    closeButton: true
  }, __jsx(Modal.Title, null, provider, __jsx("p", {
    className: "".concat(styles.productName, " text-muted mb-0")
  }, details.product))), __jsx(Modal.Body, null, details.hasOwnProperty('apply') && __jsx(Link, {
    href: details.apply.indexOf("".concat(process.env.NEXT_PUBLIC_SITE_URL)) > -1 ? "".concat(details.apply).concat(applyParams.length > 0 ? '?' + applyParams : '') : details.apply
  }, __jsx("a", {
    onClick: onApply,
    rel: relOpennerTag,
    target: details.apply.indexOf("".concat(process.env.NEXT_PUBLIC_SITE_URL)) > -1 ? '_self' : '_blank',
    title: "Solicit\u0103 oferta",
    className: "btn btn-primary mt-2 mb-3"
  }, "Solicit\u0103 oferta", __jsx(FontAwesomeIcon, {
    className: "ml-2",
    icon: faChevronRight,
    height: "16",
    width: "16"
  }))), __jsx(Row, {
    className: styles.endSection
  }, __jsx(Col, {
    xs: "12",
    className: styles.productSection
  }, "Cost total"), __jsx(Col, {
    xs: "12",
    md: "5",
    className: styles.key
  }, "DAE"), __jsx(Col, {
    xs: "12",
    md: "7",
    className: styles.info
  }, Intl.NumberFormat('fr', {
    maximumFractionDigits: 2
  }).format(details.apr), " %"), __jsx(Col, {
    xs: "12",
    md: "5",
    className: styles.key
  }, "Cost total"), __jsx(Col, {
    xs: "12",
    md: "7",
    className: "".concat(styles.info)
  }, Intl.NumberFormat('fr', {
    maximumFractionDigits: 0
  }).format(details.totalCost), " lei"), __jsx(Col, {
    xs: "12",
    md: "5",
    className: styles.key
  }, "Suma de rambursat"), __jsx(Col, {
    xs: "12",
    md: "7",
    className: "".concat(styles.info)
  }, Intl.NumberFormat('fr', {
    maximumFractionDigits: 0
  }).format(details.totalAmount), " lei")), __jsx(Row, {
    className: styles.endSection
  }, __jsx(Col, {
    xs: "12",
    className: styles.productSection
  }, "Dob\xE2nd\u0103 \u0219i comisioane"), __jsx(Col, {
    xs: "12",
    md: "5",
    className: styles.key
  }, "Rata dob\xE2nzii"), __jsx(Col, {
    xs: "12",
    md: "7",
    className: styles.info
  }, Intl.NumberFormat('fr', {
    maximumFractionDigits: 2
  }).format(details.rate), "% pe zi"), __jsx(Col, {
    xs: "12",
    md: "5",
    className: styles.key
  }, "Tip dob\xE2nd\u0103"), __jsx(Col, {
    xs: "12",
    md: "7",
    className: styles.info
  }, details.rateType), __jsx(Col, {
    xs: "12",
    md: "5",
    className: styles.key
  }, "Comision"), __jsx(Col, {
    xs: "12",
    md: "7",
    className: styles.info
  }, details.fee, " lei"), __jsx(Col, {
    xs: "12",
    md: "5",
    className: styles.key
  }, "Comision prelungire credit"), __jsx(Col, {
    xs: "12",
    md: "7",
    className: styles.info
  }, details.rolloverFee), __jsx(Col, {
    xs: "12",
    md: "5",
    className: styles.key
  }, "Comision penalizare \xEEnt\xE2rziere"), __jsx(Col, {
    xs: "12",
    md: "7",
    className: styles.info
  }, details.penaltyFee)), __jsx(Row, {
    className: styles.endSection
  }, __jsx(Col, {
    xs: "12",
    className: styles.productSection
  }, "Eligibilitate"), __jsx(Col, {
    xs: "12",
    md: "5",
    className: styles.key
  }, "V\xE2rsta minim\u0103"), __jsx(Col, {
    xs: "12",
    md: "7",
    className: styles.info
  }, details.minAge), __jsx(Col, {
    xs: "12",
    md: "5",
    className: styles.key
  }, "Venit minim"), __jsx(Col, {
    xs: "12",
    md: "7",
    className: styles.info
  }, details.minIncome), __jsx(Col, {
    xs: "12",
    md: "5",
    className: styles.key
  }, "Alte condi\u021Bii"), __jsx(Col, {
    xs: "12",
    md: "7",
    className: styles.info
  }, details.terms))), __jsx(Modal.Footer, {
    className: "justify-content-between"
  }, details.hasOwnProperty('apply') && __jsx(Link, {
    href: details.apply.indexOf("".concat(process.env.NEXT_PUBLIC_SITE_URL)) > -1 ? "".concat(details.apply).concat(applyParams.length > 0 ? '?' + applyParams : '') : details.apply
  }, __jsx("a", {
    onClick: onApply,
    rel: relOpennerTag,
    target: details.apply.indexOf("".concat(process.env.NEXT_PUBLIC_SITE_URL)) > -1 ? '_self' : '_blank',
    title: "Solicit\u0103 oferta",
    className: "btn btn-primary mt-2 mb-3"
  }, "Solicit\u0103 oferta", __jsx(FontAwesomeIcon, {
    className: "ml-2",
    icon: faChevronRight,
    height: "16",
    width: "16"
  }))), __jsx(Button, {
    variant: "outline-secondary",
    onClick: handleClose
  }, "\xCEnchide")));
};

export default PaydayLoanDetails;